export default __webpack_public_path__ + "static/image-7-9b42fc39e9fd5ac5dd0551d8324adcee.jpg";